import { render, staticRenderFns } from "./MetaDescScores.vue?vue&type=template&id=35d7ff6d&scoped=true&"
import script from "./MetaDescScores.vue?vue&type=script&lang=js&"
export * from "./MetaDescScores.vue?vue&type=script&lang=js&"
import style0 from "./MetaDescScores.vue?vue&type=style&index=0&id=35d7ff6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7ff6d",
  null
  
)

/* custom blocks */
import block0 from "./MetaDescScores.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports